import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3fe44b8e&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=3fe44b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe44b8e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/vercel/path0/components/Logo.vue').default,AvatarBeta: require('/vercel/path0/components/AvatarBeta.vue').default})
